import "core-js/stable";
import "regenerator-runtime/runtime";
import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    paymentMethod: String,
    tableUrl: String,
    confirmationUrls: Object,
  };

  async send(event) {
    event.preventDefault();
    event.stopPropagation();

    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData);
    const paymentMethod = data[this.paymentMethodValue];
    const redirectUrl = this.confirmationUrlsValue[paymentMethod];

    for (const key in data) {
      if (key.startsWith("ignore__")) delete data[key];

      data[key] = data[key]?.normalize("NFD")?.trim();
    }

    const method = "POST";
    const body = JSON.stringify(data);
    const headers = { "Content-Type": "application/json" };
    const tableUrl = new URL(this.tableUrlValue);

    tableUrl.host = window.location.host;

    this.formDisable(event.target, true);

    let response;
    let retries = 0;
    const totalRetries = 5;

    do {
      try {
        response = await fetch(tableUrl, { method, body, headers });

        if (!response.ok) throw "Server error";

        break;
      } catch (e) {
        retries++;

        await (new Promise(r => setTimeout(r, 1000)));

        if (retries <= totalRetries) continue;

        console.error(e, JSON.stringify({ status: response?.status, url: response?.url, body }));
      }
    } while (retries <= totalRetries);

    // Darle un segundo a que se terminen las peticiones (!)
    setTimeout(() => Turbolinks.visit(redirectUrl), 1000);

    this.formDisable(event.target, false);
  }

  formDisable(form, disable) {
    Array.from(form.elements).forEach((x) => (x.disabled = disable));
  }
}
